import { useSelector } from 'react-redux';

// Import utilities
import { useOperators } from 'components/utilities';

// Import helpers
import useEpgItemTime from 'components/views/tv/epg/grid/epg_grid_collection/epg_grid_item/useEpgItemTime';

const useProgramToolbar = () => {
	const { since, till, uuid: programId, channel_uuid } = useSelector(
		({ program_details }) => program_details.data
	);
	const { isUpcoming, isNotEnded } = useEpgItemTime({ till, since });
	const { isDvrRecordingsOperator } = useOperators();
	const { data } = useSelector(({ devices }) => devices);
	const { lives: channels } = useSelector(({ channels }) => channels.data);
	const channel = channels.find((channel) => channel.uuid === channel_uuid);
	const isChannelAvailable = channel?.avaiable;

	const isNpvrActive = channel?.context?.npvr_active && isNotEnded;
	const isDvrActive = isNotEnded && data.length > 0 && isDvrRecordingsOperator;
	const isRecordingEnabled = isNpvrActive || isDvrActive;
	const isRecordingsPanelVisible =
		isRecordingEnabled && isChannelAvailable && isDvrRecordingsOperator;

	return {
		isRecordingsPanelVisible,
		isUpcoming,
		programId,
		since,
		till,
		isNpvrActive,
		isDvrActive
	};
};

export default useProgramToolbar;
